import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import * as React from "react";
import Grid from "@mui/material/Grid";
import {Link} from "react-router-dom";

export default function NoDataComponent() {
    return (
        <Box
            display="flex"
            height="100%"
            width="100%"
        >
            <Grid container spacing={3}>
                <Grid item xs={12} sx={{
                    justifyContent: "center",
                    alignItems: "center", display: "flex"
                }}>
                    <Box display="flex">
                        <Typography
                            variant="h6"
                            color="inherit"
                            noWrap
                            sx={{flexGrow: 1}}
                        >
                            <b>Brak danych!</b>
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={12} sx={{
                    justifyContent: "center",
                    alignItems: "center", display: "flex"
                }}>
                    <Box display="flex">
                        <Typography
                            variant="body1"
                            color="inherit"
                            noWrap
                            sx={{flexGrow: 1}}
                        >
                            Przejdź na&nbsp;<Link to="/">stronę główną</Link>&nbsp;i prześlij pliki, aby rozpocząć korzystanie z serwisu.
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}